import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Mail, Loader2, Paperclip } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { errMsg } from './api';
import { EmailsInput, splitEmails } from './EmailsInput';

export const DevisEmailDialog = ({ open, onOpenChange, session, api, onSent }) => {
  const [form, setForm] = useState(null);
  const [sending, setSending] = useState(false);
  useEffect(() => {
    if (!open) return;
    setForm(null);
    api.devisEmail(session.id).then(setForm).catch((e) => { toast.error(errMsg(e, 'Préparation impossible')); onOpenChange(false); });
  }, [open, session.id, api, onOpenChange]);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const send = async () => {
    setSending(true);
    try {
      const s = await api.sendDevisEmail(session.id, form);
      onSent(s);
      const last = (s.devis_envois || []).slice(-1)[0] || {};
      if ((last.echecs || []).length) toast.warning(`Envoyé à ${last.to} — échec pour ${last.echecs.join(', ')}`);
      else toast.success(`Devis envoyé à ${splitEmails(form.email).join(', ')}`);
      onOpenChange(false);
    }
    catch (e) { toast.error(errMsg(e, "Erreur d'envoi du devis")); }
    finally { setSending(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-xl" data-testid="ia-devis-email-dialog">
        <DialogHeader><DialogTitle>Envoyer le devis au demandeur</DialogTitle></DialogHeader>
        {!form ? <Loader2 className="h-5 w-5 animate-spin text-violet-500" /> : (
          <div className="space-y-3">
            <div className="grid grid-cols-2 gap-3">
              <label className="text-xs text-slate-600 space-y-1 col-span-2"><span>Destinataires (plusieurs adresses possibles)</span>
                <EmailsInput value={form.email} onChange={(v) => set('email', v)} /></label>
              <label className="text-xs text-slate-600 space-y-1 col-span-2"><span>Nom</span>
                <Input value={form.nom} onChange={(e) => set('nom', e.target.value)} data-testid="ia-devis-email-nom" /></label>
            </div>
            <label className="block text-xs text-slate-600 space-y-1"><span>Sujet</span>
              <Input value={form.sujet} onChange={(e) => set('sujet', e.target.value)} data-testid="ia-devis-email-sujet" /></label>
            <label className="block text-xs text-slate-600 space-y-1"><span>Message</span>
              <Textarea rows={9} value={form.message} onChange={(e) => set('message', e.target.value)} data-testid="ia-devis-email-message" /></label>
            <p className="flex items-start gap-1.5 text-[11px] text-slate-500"><Paperclip className="h-3 w-3 mt-0.5" /> Pièces jointes : {form.pieces_jointes.join(' + ')}. Un lien de consultation suivi est ajouté à l'email.</p>
          </div>
        )}
        <DialogFooter>
          <Button variant="ghost" onClick={() => onOpenChange(false)}>Annuler</Button>
          <Button onClick={send} disabled={!form || sending} className="bg-violet-600 hover:bg-violet-700 text-white gap-2" data-testid="ia-devis-email-send-btn">
            {sending ? <Loader2 className="h-4 w-4 animate-spin" /> : <Mail className="h-4 w-4" />} Envoyer
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
